<template>
<div>
    <div v-if="!activatedClub">
        <div v-for="club in clubList">
            <leagueRankingPanel v-if="clubList" :club="club"></leagueRankingPanel>
        </div>
    </div>
    <div v-else>
        <leagueRankingPanel :club="activatedClub" :key="activatedClub.id"></leagueRankingPanel>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import leagueRankingPanel from './league-ranking-panel.vue'

export default {
  name: 'ranking',
  components: {
    spinner,
    leagueRankingPanel
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'ranking',
      'clubList',
      'activatedClub'
    ])
  },
  methods: {
  },
  created () {
    store.dispatch('showLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ranking.vue?17311797